export enum LocalStorageKeys {
	AUTH_TOKEN = 'AUTH_TOKEN',
	RESELLER_TOUR = 'RESELLER_TOUR',
	NOVI_AUTH_TOKEN = 'NOVI_AUTH_TOKEN',
	NOVI_USER = 'NOVI_USER',
	RESELLER_AUTH_TOKEN = 'RESELLER_AUTH_TOKEN',
	NOVI_RECEPTIONIST_AUTH_TOKEN = 'NOVI_RECEPTIONIST_AUTH_TOKEN',
	FAVICON_URL = 'FAVICON_URL',
	DATE_FORMAT = 'DATE_FORMAT',
	RESELLER_ONBOARDING = 'RESELLER_ONBOARDING',
	QUESTIONNAIRE_FORM_DATA = 'QUESTIONNAIRE_FORM_DATA',
	COMPLETED_ACTIONS = 'COMPLETED_ACTIONS',
	METRICS_TOKEN_KEY = 'metrics_token',
	ONBOARDING_STORAGE_KEY = 'onboarding_progress',
	HAS_CLAIMED_FREE_CALL_KEY = 'hasClaimedFreeCall',
	ADMIN_AUTH_TOKEN = 'ADMIN_AUTH_TOKEN',
	NPS_DISMISSED_AT = 'nps_dismissed_at',
	NPS_FIRST_DISMISSED_AT = 'nps_first_dismissed_at',
	AFFILIATE_AUTH_TOKEN = 'AFFILIATE_AUTH_TOKEN',
	AFFILIATE_DATA = 'AFFILIATE_DATA',
	CELLO_TOKEN = 'CELLO_TOKEN',
}
